export default __webpack_public_path__ + "static/media/MeatInspection.80707e9f.jpg";